export default {
  myTrainingClass_check_training: '0408Web-View training classes',
  myTrainingClass_show_training: '0407Web-Display my list of training classes',
  myTrainingClass_check_news0602: '0602Web-View message',
  myTrainingClass_my_news: 'My messages',
  myTrainingClass_show_news: '0601Web-Show message list',
  myTrainingClass_news06: '06Web-Message',
}
